import Converter from './Converter';
import { shortLanguages } from 'services/locale';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  gameListUrl: `upgaming/game/list?partner_name=${projectName}`,
  converter,
  gameListUrlData: {
    getHeaders: () => ({
      'Content-Type': 'application/json',
      headers: { 'x-partner-name': projectName },
    }),
  },
  sessionUrlData: {
    url: 'upgaming/game/launch',
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
    getQuery: params =>
      // eslint-disable-next-line max-len
      `?game_id=${params.gameId}&is_mobile=${params.isMobile ?? false}&lang=${
        shortLanguages[params.lang as keyof typeof shortLanguages]
      }`,
    getHeaders: () => ({
      headers: {
        'x-partner-authorization': parseCookies(),
        'x-partner-name': projectName,
      },
    }),
  },
};
